import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppLayout } from '@/widgets/app-layout';
import { ProtectedRoute } from './protected-route';

// Each page becomes its own chunk; AppLayout renders the Suspense boundary.
const DashboardPage = lazy(() =>
  import('@/pages/dashboard').then((module) => ({ default: module.DashboardPage })),
);
const GamesPage = lazy(() =>
  import('@/pages/games').then((module) => ({ default: module.GamesPage })),
);
const GameDetailsPage = lazy(() =>
  import('@/pages/game-details').then((module) => ({ default: module.GameDetailsPage })),
);
const LoginPage = lazy(() =>
  import('@/pages/login').then((module) => ({ default: module.LoginPage })),
);
const RegisterPage = lazy(() =>
  import('@/pages/register').then((module) => ({ default: module.RegisterPage })),
);
const ProfilePage = lazy(() =>
  import('@/pages/profile').then((module) => ({ default: module.ProfilePage })),
);
const PlaythroughsPage = lazy(() =>
  import('@/pages/playthroughs').then((module) => ({ default: module.PlaythroughsPage })),
);
const PlaythroughDetailsPage = lazy(() =>
  import('@/pages/playthrough-details').then((module) => ({
    default: module.PlaythroughDetailsPage,
  })),
);
const QuestPage = lazy(() =>
  import('@/pages/quest').then((module) => ({ default: module.QuestPage })),
);
const ObjectPage = lazy(() =>
  import('@/pages/knowledge-object').then((module) => ({ default: module.ObjectPage })),
);
const AdminPage = lazy(() =>
  import('@/pages/admin').then((module) => ({ default: module.AdminPage })),
);
const NotFoundPage = lazy(() =>
  import('@/pages/not-found').then((module) => ({ default: module.NotFoundPage })),
);

export function AppRouter() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="games" element={<GamesPage />} />
        <Route path="games/:slug" element={<GameDetailsPage />} />
        {/* Public, like the game page: a quest is readable without a playthrough. */}
        <Route path="games/:slug/quests/:code" element={<QuestPage />} />
        {/* Everything that is not a quest. The kind is in the path because codes are unique
            per game and kind, not per game. */}
        <Route path="games/:slug/objects/:type/:code" element={<ObjectPage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="register" element={<RegisterPage />} />

        <Route element={<ProtectedRoute />}>
          <Route path="profile" element={<ProfilePage />} />
        </Route>

        <Route element={<ProtectedRoute permission="playthroughs:read" />}>
          <Route path="playthroughs" element={<PlaythroughsPage />} />
          <Route path="playthroughs/:id" element={<PlaythroughDetailsPage />} />
        </Route>

        {/* users:read, not users:manage — somebody doing support should be able to look
            without being able to act. */}
        <Route element={<ProtectedRoute permission="users:read" />}>
          <Route path="admin" element={<AdminPage />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
